var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"q-spinner q-spinner-geo",class:_vm.classes,attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 148 148"}},[_c('use',{attrs:{"xlink:href":require('assets/mobilleo-icon-blue.svg') + '#mobilleo-icon-blue'}})])}
var staticRenderFns = []

export { render, staticRenderFns }